import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import { TRANSITION } from '@shared/types/constants/animations';

interface Props {
  focused?: boolean;
  opacity: number;
}

const ChannelListEventArrowLeftContainer = styled.div<Props>`
  position: fixed;
  top: ${522 * Screen.widthRatio}px;
  right: ${1316 * Screen.widthRatio}px;
  opacity: ${(props) => (props.focused ? props.opacity || 0 : 0)};
  transition: ${TRANSITION.ARROW_FADE};
`;

export default ChannelListEventArrowLeftContainer;
